import { render, staticRenderFns } from "./o-header.vue?vue&type=template&id=33baf610&scoped=true"
import script from "./o-header.vue?vue&type=script&lang=js"
export * from "./o-header.vue?vue&type=script&lang=js"
import style0 from "./o-header.vue?vue&type=style&index=0&id=33baf610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33baf610",
  null
  
)

export default component.exports